// Resets scroll position after each route change so new pages open from the top.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
}
